import { render, staticRenderFns } from "./ModalAddSides.vue?vue&type=template&id=6acec2ec&scoped=true&"
import script from "./ModalAddSides.vue?vue&type=script&lang=js&"
export * from "./ModalAddSides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acec2ec",
  null
  
)

export default component.exports